module.exports = __webpack_public_path__ + "img/product_outdoor.97f7dde7.jpg";